import { HiPhone, HiMail, HiAcademicCap, HiMap } from "react-icons/hi";
export const contactInfo = [
  { id: 1, label: "12334545", icon: <HiPhone />, value: "" },
  {
    id: 2,
    label: "abc@example.com",
    icon: <HiMail />,
    value: "",
  },
  {
    id: 3,
    value: "",
    icon: <HiAcademicCap />,
    label: "link profile",
  },
  {
    id: 4,
    value: "",
    icon: <HiMap />,
    label: "address",
  },
];
